import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";
import { VKSnabbkalkylDTO } from "../../models/tradslag/snabbkalkyl-models";

export class UpdateSnabbkalkylCommand extends BasicCommand<UpdateSnabbkalkylCommand> {
    readonly snabbkalkyl: VKSnabbkalkylDTO;
    readonly atgardGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateSnabbkalkylCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Snabbkalkyl";

    get primaryKey(): IPrimaryKey<UpdateSnabbkalkylCommand> {
        return {
            guid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, snabbkalkyl: VKSnabbkalkylDTO) {
        super(UpdateSnabbkalkylCommand.$type, UpdateSnabbkalkylCommand.$groupKey, CommandType.Replace);
        this.snabbkalkyl = snabbkalkyl;
        this.atgardGuid = atgardGuid;
    }
}
